declare namespace $ {

	type $mol_button_minor__title_shm_service_mode_controls_1 = $mol_type_enforce<
		ReturnType< $shm_service_mode_controls['edit_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_service_mode_controls_2 = $mol_type_enforce<
		ReturnType< $shm_service_mode_controls['edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__style_shm_service_mode_controls_3 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_service_mode_controls['edit_color'] >,
		})  & ReturnType< $mol_button_minor['style'] >
		,
		ReturnType< $mol_button_minor['style'] >
	>
	type $mol_button_minor__title_shm_service_mode_controls_4 = $mol_type_enforce<
		ReturnType< $shm_service_mode_controls['view_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_service_mode_controls_5 = $mol_type_enforce<
		ReturnType< $shm_service_mode_controls['view_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_service_mode_controls_6 = $mol_type_enforce<
		ReturnType< $shm_service_mode_controls['view'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__style_shm_service_mode_controls_7 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_service_mode_controls['view_color'] >,
		})  & ReturnType< $mol_button_minor['style'] >
		,
		ReturnType< $mol_button_minor['style'] >
	>
	export class $shm_service_mode_controls extends $mol_view {
		edit( next?: any ): any
		Edit( ): $mol_button_minor
		view( next?: any ): any
		View( ): $mol_button_minor
		edit_title( ): string
		view_title( ): string
		view_enabled( ): boolean
		edit_color( ): string
		view_color( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=controls.view.tree.d.ts.map